module.exports = __webpack_public_path__ + "img/assign_a_driver_small.821d931a.svg";